import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FillAndSignFilledSvg = function FillAndSignFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 13.613 14.539 2.249l4.615 4.545L7.615 18.158H3zm12.413 3.947a.56.56 0 0 1 .51-.311.58.58 0 0 1 .51.31l.014.027a.6.6 0 0 1-.116.703l-.408.402-.408-.402a.605.605 0 0 1-.115-.703zm2.223 2.015-.376.37a2.8 2.8 0 0 0 1.577.486H21v1.818h-2.163c-1.061 0-2.09-.36-2.914-1.02a4.66 4.66 0 0 1-2.914 1.02H3.23v-1.818h9.778a2.8 2.8 0 0 0 1.577-.486l-.376-.37a2.394 2.394 0 0 1-.461-2.802l.012-.027c.2-.395.51-.728.891-.96a2.44 2.44 0 0 1 2.542 0c.382.232.69.565.89.96l.014.028a2.39 2.39 0 0 1-.462 2.8",
    clipRule: "evenodd"
  }));
};
export var FillAndSignFilled = function FillAndSignFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FillAndSignFilledSvg
  }));
};